module.exports = __webpack_public_path__ + "img/palette.57932fc6.svg";